// 2024 Topps Star Wars Masterwork — GENERATED by pipeline-publish (2026-05-24)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/2024-masterwork.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "2024-masterwork",
//     name: "2024 Topps Star Wars Masterwork",
//     shortName: "Masterwork 2024",
//     year: 2024,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "2024",
//     totalCards: 519,
//     description: "Topps 2024 Topps Star Wars Masterwork trading card set.",
//     color: "#c9a227",
//     accentColor: "#f0c040",
//     dataFile: "2024-masterwork",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base-cards",
    type: "base",
    title: "BASE CARDS",
    parallels: [
        { id: "blue", name: "Blue", print_run: null, color: "#2979ff" },
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "red", name: "Red", print_run: 25, color: "#ff1744" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "1", name: "Han Solo" },
        { n: "2", name: "Darth Maul" },
        { n: "3", name: "Count Dooku" },
        { n: "4", name: "General Grievous" },
        { n: "5", name: "Baylan Skoll" },
        { n: "6", name: "Shin Hati" },
        { n: "7", name: "Marrok" },
        { n: "8", name: "Asajj Ventress" },
        { n: "9", name: "Jyn Erso" },
        { n: "10", name: "Ahsoka Tano" },
        { n: "11", name: "Lando Calrissian" },
        { n: "12", name: "Nien Nunb" },
        { n: "13", name: "Admiral Ackbar" },
        { n: "14", name: "Carson Teva" },
        { n: "15", name: "Captain Phasma" },
        { n: "16", name: "Stormtrooper" },
        { n: "17", name: "Bo-Katan Kryze" },
        { n: "18", name: "Koska Reeves" },
        { n: "19", name: "Boba Fett" },
        { n: "20", name: "Darth Vader" },
        { n: "21", name: "General Draven" },
        { n: "22", name: "Baze Malbus" },
        { n: "23", name: "Porg" },
        { n: "24", name: "Figrin D'an" },
        { n: "25", name: "Krrsantan" },
        { n: "26", name: "Greedo" },
        { n: "27", name: "Enfys Nest" },
        { n: "28", name: "Poe Dameron" },
        { n: "29", name: "Rey" },
        { n: "30", name: "Kylo Ren" },
        { n: "31", name: "Tallie Lintra" },
        { n: "32", name: "Salacious B. Crumb" },
        { n: "33", name: "Bib Fortuna" },
        { n: "34", name: "Beezer Fortuna" },
        { n: "35", name: "Jabba the Hutt" },
        { n: "36", name: "Garsa Fwip" },
        { n: "37", name: "Droideka" },
        { n: "38", name: "Jannah" },
        { n: "39", name: "Max Rebo" },
        { n: "40", name: "Chancellor Palpatine" },
        { n: "41", name: "Mace Windu" },
        { n: "42", name: "Jango Fett" },
        { n: "43", name: "Lok Durd" },
        { n: "44", name: "Vice Admiral Holdo" },
        { n: "45", name: "The Modifier" },
        { n: "46", name: "Ponda Baba" },
        { n: "47", name: "Doctor Cornelius Evazan" },
        { n: "48", name: "Ric Olié" },
        { n: "49", name: "Chewbacca" },
        { n: "50", name: "Luke Skywalker" },
        { n: "51", name: "Ezra Bridger" },
        { n: "52", name: "Sabine Wren" },
        { n: "53", name: "Hera Syndulla" },
        { n: "54", name: "Kanan Jarrus" },
        { n: "55", name: "Chopper" },
        { n: "56", name: "Garazeb Orrelios" },
        { n: "57", name: "Jek Porkins" },
        { n: "58", name: "Captain Panaka" },
        { n: "59", name: "Oma Tres" },
        { n: "60", name: "Obi-Wan Kenobi" },
        { n: "61", name: "Nute Gunray" },
        { n: "62", name: "Dedra Meero" },
        { n: "63", name: "Syril Karn" },
        { n: "64", name: "Admiral Motti" },
        { n: "65", name: "Padmé Amidala" },
        { n: "66", name: "Anakin Skywalker" },
        { n: "67", name: "R5-D4" },
        { n: "68", name: "Sy Snootles" },
        { n: "69", name: "The Dutchess" },
        { n: "70", name: "R2-D2" },
        { n: "71", name: "C-3PO" },
        { n: "72", name: "Supreme Leader Snoke" },
        { n: "73", name: "Tala Durith" },
        { n: "74", name: "Sebulba" },
        { n: "75", name: "Reva" },
        { n: "76", name: "Major Bren Derlin" },
        { n: "77", name: "Huyang" },
        { n: "78", name: "Luthen Rael" },
        { n: "79", name: "Captain Bombardier" },
        { n: "80", name: "Leia Organa" },
        { n: "81", name: "Wicket W. Warrick" },
        { n: "82", name: "Zorii Bliss" },
        { n: "83", name: "Tobias Beckett" },
        { n: "84", name: "Master Codebreaker" },
        { n: "85", name: "The Rancor" },
        { n: "86", name: "The Rancor Keeper" },
        { n: "87", name: "Malakili" },
        { n: "88", name: "Unkar Plutt" },
        { n: "89", name: "Yaddle" },
        { n: "90", name: "Yoda" },
        { n: "91", name: "Grogu" },
        { n: "92", name: "Even Piell" },
        { n: "93", name: "Plo Koon" },
        { n: "94", name: "Jacen Syndulla" },
        { n: "95", name: "Kelleran Beq" },
        { n: "96", name: "Tasu Leech" },
        { n: "97", name: "Poggle the Lesser" },
        { n: "98", name: "Admiral Piett" },
        { n: "99", name: "The Mandalorian" },
        { n: "100", name: "Grand Admiral Thrawn" },
    ],
  },
  {
    id: "artoo-detoo",
    type: "insert",
    title: "ARTOO-DETOO",
    parallels: [],
    cards: [
        { n: "AR-1", name: "Protecting The Queen" },
        { n: "AR-2", name: "R2's Droid Factory Frolic" },
        { n: "AR-3", name: "Buzz Droid Zapped!" },
        { n: "AR-4", name: "Oil And Fire" },
        { n: "AR-5", name: "\"Help Me Obi-Wan Kenobi\"" },
        { n: "AR-6", name: "R2-D2's Heroic Salvage" },
        { n: "AR-7", name: "Hit By Darth Vader" },
        { n: "AR-8", name: "Master Luke Lost" },
        { n: "AR-9", name: "Return Of The Jedi's Lightsaber" },
        { n: "AR-10", name: "R2's Bunker Breakdown" },
    ],
  },
  {
    id: "behind-the-new-scenes",
    type: "insert",
    title: "BEHIND THE NEW SCENES",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "BTS-1", name: "J.J. Abrams And Daisy Ridley" },
        { n: "BTS-2", name: "Stormtoopers Of The First Order" },
        { n: "BTS-3", name: "The Scavenger And The Droid" },
        { n: "BTS-4", name: "J.J. Abrams With John Boyega And Oscar Isaac" },
        { n: "BTS-5", name: "The Journey Begins" },
        { n: "BTS-6", name: "Rian Johnson and Mark Hamill in the Falcon" },
        { n: "BTS-7", name: "Rian Johnson With Oscar Isaac" },
        { n: "BTS-8", name: "At The Mirror Cave" },
        { n: "BTS-9", name: "Rian Johnson With Benicio Del Toro" },
        { n: "BTS-10", name: "Mark Hamill With The Droid" },
        { n: "BTS-11", name: "Rian Johnson Frames The Shot" },
        { n: "BTS-12", name: "Captain Phasma With Her Army" },
        { n: "BTS-13", name: "A Moment Of Joy For Mark Hamill" },
        { n: "BTS-14", name: "The Resistance Celebrates" },
        { n: "BTS-15", name: "The Droids On Kef Bir" },
        { n: "BTS-16", name: "R2-D2 Plus Two" },
        { n: "BTS-17", name: "J.J. Abrams And The Wookiee Collaborate" },
        { n: "BTS-18", name: "The Resistance At The Festival Of The Ancestors" },
        { n: "BTS-19", name: "J.J. Abrams And Adam Driver Discuss A Dark Moment" },
        { n: "BTS-20", name: "An Embrace On Pasaana" },
        { n: "BTS-21", name: "Daisy Ridley Channels The Force For The Camera" },
        { n: "BTS-22", name: "Chewbacca's Close-up" },
        { n: "BTS-23", name: "The Resistance Co-Generals Share A Laugh" },
    ],
  },
  {
    id: "see-threepio",
    type: "insert",
    title: "SEE-THREEPIO",
    parallels: [],
    cards: [
        { n: "CP-1", name: "Reunited" },
        { n: "CP-2", name: "Into The Clone Wars Head First" },
        { n: "CP-3", name: "Witness To A Secret Wedding" },
        { n: "CP-4", name: "Feeling So Helpless" },
        { n: "CP-5", name: "Organa Orders A Mind Wipe" },
        { n: "CP-6", name: "Lost On Tatooine" },
        { n: "CP-7", name: "Telling Han The Odds" },
        { n: "CP-8", name: "A Wookiee's Chatty Backpack" },
        { n: "CP-9", name: "Knock Knock Knocking On Jabba's door" },
        { n: "CP-10", name: "In Defense Of Hera Syndulla" },
    ],
  },
  {
    id: "force-spirits",
    type: "insert",
    title: "FORCE SPIRITS",
    parallels: [],
    cards: [
        { n: "FS-1", name: "Anakin Skywalker" },
        { n: "FS-2", name: "Obi-Wan Kenobi" },
        { n: "FS-3", name: "Yoda" },
        { n: "FS-4", name: "Qui-Gon Jinn" },
        { n: "FS-5", name: "Leia Organa" },
        { n: "FS-6", name: "Luke Skywalker" },
    ],
  },
  {
    id: "the-grand-admiral",
    type: "insert",
    title: "THE GRAND ADMIRAL",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "HG-1", name: "Steps Into Shadows" },
        { n: "HG-2", name: "Appreciating The Kalikori" },
        { n: "HG-3", name: "Recruiting the Magistrate" },
        { n: "HG-4", name: "The Admiral And The Spy" },
        { n: "HG-5", name: "Narrowing The Search" },
        { n: "HG-6", name: "Sparring With Droids" },
        { n: "HG-7", name: "Ready For Anything" },
        { n: "HG-8", name: "The Pursuit Of Mon Mothma" },
        { n: "HG-9", name: "Fighting Kallus" },
        { n: "HG-10", name: "Sending The Fleet To Atollon" },
        { n: "HG-11", name: "Confronting Rebel Leaders" },
        { n: "HG-12", name: "Face To Face With Bendu" },
        { n: "HG-13", name: "A Perfect Oppurtinity" },
        { n: "HG-14", name: "Dispatching Agent Rukh" },
        { n: "HG-15", name: "Hera Syndulla Captured" },
        { n: "HG-16", name: "The Admiral And The Jedi" },
        { n: "HG-17", name: "Hijacked By Purrgil" },
        { n: "HG-18", name: "Reunion On Another Galaxy" },
        { n: "HG-19", name: "Ahsoka Lives, Prepare Accordingly" },
        { n: "HG-20", name: "Long Live The Empire" },
    ],
  },
  {
    id: "journey-of-ahsoka-tano",
    type: "insert",
    title: "JOURNEY OF AHSOKA TANO",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "JA-1", name: "The Child & The Force" },
        { n: "JA-2", name: "Discovered By Plo Koon" },
        { n: "JA-3", name: "Enter \"Snips\"" },
        { n: "JA-4", name: "Infected" },
        { n: "JA-5", name: "Strange Occurrences On Mortis" },
        { n: "JA-6", name: "Wookiee Hunt" },
        { n: "JA-7", name: "A Jedi No More" },
        { n: "JA-8", name: "Under Siege" },
        { n: "JA-9", name: "Hunted By An Inquisitor" },
        { n: "JA-10", name: "Twilight of the Apprentice" },
        { n: "JA-11", name: "A Long Awaited Meeting" },
        { n: "JA-12", name: "The Search for Ezra And Thrawn" },
        { n: "JA-13", name: "A Mandalorian and A Former Jedi" },
        { n: "JA-14", name: "Defeating The Magistrate" },
        { n: "JA-15", name: "Clash In Corellia" },
        { n: "JA-16", name: "Space Duel" },
        { n: "JA-17", name: "Fallen Jedi" },
        { n: "JA-18", name: "Far, Far Away" },
        { n: "JA-19", name: "Heroes Move In" },
        { n: "JA-20", name: "Rematch with the Nightsister Witch" },
    ],
  },
  {
    id: "marvel-comic-covers",
    type: "insert",
    title: "MARVEL COMIC COVERS",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "MC-1", name: "Star Wars #1, July 1977" },
        { n: "MC-2", name: "Star Wars #7, January 1978" },
        { n: "MC-3", name: "Star Wars #11, May 1978" },
        { n: "MC-4", name: "Star Wars #18, December 1978" },
        { n: "MC-5", name: "Star Wars #13, July 1978" },
        { n: "MC-6", name: "Star Wars #21, March 1979" },
        { n: "MC-7", name: "Star Wars #24, June 1979" },
        { n: "MC-8", name: "Star Wars #30, December 1979" },
        { n: "MC-9", name: "Star Wars #31, January 1980" },
        { n: "MC-10", name: "Star Wars #35, May 1980" },
        { n: "MC-11", name: "Star Wars #38, August 1980" },
        { n: "MC-12", name: "Star Wars #39, September 1980" },
        { n: "MC-13", name: "Star Wars #52, October 1981" },
        { n: "MC-14", name: "Star Wars #63, September 1982" },
        { n: "MC-15", name: "Star Wars #64, October 1982" },
        { n: "MC-16", name: "Star Wars #65, November 1982" },
        { n: "MC-17", name: "Star Wars #68, February 1983" },
        { n: "MC-18", name: "Star Wars #69, March 1983" },
        { n: "MC-19", name: "Star Wars #70, April 1983" },
        { n: "MC-20", name: "Star Wars #71, May 1983" },
        { n: "MC-21", name: "Star Wars #73, July 1983" },
        { n: "MC-22", name: "Star Wars #80, February 1984" },
        { n: "MC-23", name: "Star Wars #81, March 1984" },
        { n: "MC-24", name: "Star Wars #86, August 1984" },
        { n: "MC-25", name: "Star Wars #90, December 1984" },
        { n: "MC-26", name: "Star Wars #91, January 1985" },
        { n: "MC-27", name: "Star Wars #92, February 1985" },
        { n: "MC-28", name: "Star Wars #94, April 1985" },
        { n: "MC-29", name: "Star Wars #95, May 1985" },
        { n: "MC-30", name: "Star Wars #98, August 1985" },
        { n: "MC-31", name: "Star Wars #100, October 1985" },
        { n: "MC-32", name: "Star Wars #101, November 1985" },
        { n: "MC-33", name: "Star Wars #107, September 1986" },
    ],
  },
  {
    id: "rise-of-the-resistance-relics",
    type: "insert",
    title: "RISE OF THE RESISTANCE RELICS",
    parallels: [
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "red", name: "Red", print_run: 25, color: "#ff1744" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "RR-B", name: "BB-8" },
        { n: "RR-F", name: "Finn" },
        { n: "RR-G", name: "General Hux" },
        { n: "RR-K", name: "Kylo Ren" },
        { n: "RR-N", name: "Nien Nunb" },
        { n: "RR-P", name: "Poe Dameron" },
        { n: "RR-R", name: "Rey" },
        { n: "RR-S", name: "Stormtrooper" },
    ],
  },
  {
    id: "stormtrooper-armor",
    type: "insert",
    title: "STORMTROOPER ARMOR",
    parallels: [
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "red", name: "Red", print_run: 25, color: "#ff1744" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "S-1", name: "Dante Briggins as Stormtrooper" },
        { n: "S-2", name: "Dante Briggins as Stormtrooper" },
        { n: "S-3", name: "Pip Andersen as Stormtrooper" },
        { n: "S-4", name: "Pip Andersen as Stormtrooper" },
        { n: "S-5", name: "Sam Witwer as Stormtrooper" },
        { n: "S-6", name: "Sam Witwer as Stormtrooper" },
        { n: "S-7", name: "Verona Blue as Stormtrooper" },
        { n: "S-8", name: "Verona Blue as Stormtrooper" },
    ],
  },
  {
    id: "on-card-autographs",
    type: "auto",
    title: "ON CARD AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "A-AA", name: "Adria Arjona as Bix Caleen" },
        { n: "A-AB", name: "Ahmed Best as Kelleran Beq" },
        { n: "A-AD", name: "Anthony Daniels as C-3PO" },
        { n: "A-AM", name: "Amy Allen as Aayla Secura" },
        { n: "A-AS", name: "Andy Serkis as Supreme Leader Snoke" },
        { n: "A-B", name: "Brian Blessed as Boss Nass" },
        { n: "A-BDW", name: "Billy Dee Williams as Lando Calrissian" },
        { n: "A-CL", name: "Christopher Lloyd as Commissioner Helgait" },
        { n: "A-DM", name: "Dominic Monaghan as Beaumont Kin" },
        { n: "A-DN", name: "Denise Gough as Dedra Meero" },
        { n: "A-EC", name: "Emilia Clarke as Qi'ra" },
        { n: "A-EE", name: "Eman Esfandi as Ezra Bridger" },
        { n: "A-EK", name: "Erin Kellyman as Enfys Nest" },
        { n: "A-ES", name: "Emily Swallow as The Armorer" },
        { n: "A-FPJ", name: "Freddie Prinze Jr. as Kanan Jarrus" },
        { n: "A-GC", name: "Gwendoline Christie as Captain Phasma" },
        { n: "A-GO", name: "Genevieve O'Reilly as Mon Mothma" },
        { n: "A-GT", name: "George Takei as Lok Durd" },
        { n: "A-IM", name: "Ian McDiarmid as Darth Sidious" },
        { n: "A-IS", name: "Ivanna Sakhno as Shin Hati" },
        { n: "A-JE", name: "Joel Edgerton as Owen Lars" },
        { n: "A-JN", name: "Jennifer Beals as Garsa Fwip" },
        { n: "A-JR", name: "John Ratzenberger as Major Bren Derlin" },
        { n: "A-KCH", name: "Keisha Castle-Hughes as Queen Apailana" },
        { n: "A-KK", name: "Keira Knightley as Sabé" },
        { n: "A-KMT", name: "Kelly Marie Tran as Rose Tico" },
        { n: "A-KR", name: "Keri Russell as Zorii Bliss" },
        { n: "A-KS", name: "Katee Sackhoff as Bo-Katan Kryze" },
        { n: "A-LM", name: "Lars Mikkelsen as Grand Admiral Thrawn" },
        { n: "A-MA", name: "Michelle Ang as Omega" },
        { n: "A-ME", name: "Maya Erskine as Sully Stark" },
        { n: "A-MEW", name: "Mary Elizabeth Winstead as Hera Syndulla" },
        { n: "A-MI", name: "Moses Ingram as Reva" },
        { n: "A-MNW", name: "Ming-Na Wen as Fennec Shand" },
        { n: "A-MW", name: "Matthew Wood as General Grievous" },
        { n: "A-NB", name: "Natasha Liu Bordizzo as Sabine Wren" },
        { n: "A-NP", name: "Natalie Portman as Padmé Amidala" },
        { n: "A-PP", name: "Pedro Pascal as The Mandalorian" },
        { n: "A-RA", name: "Riz Ahmed as Bodhi Rook" },
        { n: "A-RF", name: "Rupert Friend as The Grand Inquisitor" },
        { n: "A-RP", name: "Ray Park as Darth Maul" },
        { n: "A-SL", name: "Kyle Soller as Syril Karn" },
        { n: "A-SLJ", name: "Samuel L. Jackson as Mace Windu" },
        { n: "A-SP", name: "Simon Pegg as Unkar Plutt" },
        { n: "A-SS", name: "Stellan Skarsgård as Luthen Rael" },
        { n: "A-T", name: "Stephen Bruner as The Modifier" },
        { n: "A-TB", name: "Tom Baker as Bendu" },
        { n: "A-TC", name: "Tim Curry as Chancellor Palpatine" },
        { n: "A-TN", name: "Thandiwe Newton as Val" },
        { n: "A-WH", name: "Werner Herzog as The Client" },
    ],
  },
  {
    id: "pen-autograph-relics",
    type: "auto",
    title: "PEN AUTOGRAPH RELICS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "AP-AA", name: "Adria Arjona as Bix Caleen" },
        { n: "AP-AB", name: "Ahmed Best as Kelleran Beq" },
        { n: "AP-AD", name: "Anthony Daniels as C-3PO" },
        { n: "AP-AM", name: "Amy Allen as Aayla Secura" },
        { n: "AP-AS", name: "Andy Serkis as Supreme Leader Snoke" },
        { n: "AP-B", name: "Brian Blessed as Boss Nass" },
        { n: "AP-DM", name: "Dominic Monaghan as Beaumont Kin" },
        { n: "AP-DN", name: "Denise Gough as Dedra Meero" },
        { n: "AP-EC", name: "Emilia Clarke as Qi'ra" },
        { n: "AP-EK", name: "Erin Kellyman as Enfys Nest" },
        { n: "AP-ES", name: "Emily Swallow as The Armorer" },
        { n: "AP-FPJ", name: "Freddie Prinze Jr. as Kanan Jarrus" },
        { n: "AP-GC", name: "Gwendoline Christie as Captain Phasma" },
        { n: "AP-GO", name: "Genevieve O'Reilly as Mon Mothma" },
        { n: "AP-IS", name: "Ivanna Sakhno as Shin Hati" },
        { n: "AP-JE", name: "Joel Edgerton as Owen Lars" },
        { n: "AP-JN", name: "Jennifer Beals as Garsa Fwip" },
        { n: "AP-KK", name: "Keira Knightley as Sabé" },
        { n: "AP-KR", name: "Keri Russell as Zorii Bliss" },
        { n: "AP-KS", name: "Katee Sackhoff as Bo-Katan Kryze" },
        { n: "AP-LM", name: "Lars Mikkelsen as Grand Admiral Thrawn" },
        { n: "AP-MEW", name: "Mary Elizabeth Winstead as Hera Syndulla" },
        { n: "AP-MI", name: "Moses Ingram as Reva" },
        { n: "AP-MM", name: "Mads Mikkelsen as Galen Erso" },
        { n: "AP-MNW", name: "Ming-Na Wen as Fennec Shand" },
        { n: "AP-MW", name: "Matthew Wood as General Grievous" },
        { n: "AP-NB", name: "Natasha Liu Bordizzo as Sabine Wren" },
        { n: "AP-RA", name: "Riz Ahmed as Bodhi Rook" },
        { n: "AP-RP", name: "Ray Park as Darth Maul" },
        { n: "AP-SS", name: "Stellan Skarsgård as Luthen Rael" },
        { n: "AP-T", name: "Stephen Bruner as The Modifier" },
    ],
  },
  {
    id: "dual-autographs",
    type: "auto",
    title: "DUAL AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "DA-CB", name: "Carrie Fisher / Billy Dee Williams as Leia Organa / Lando Calrissian" },
        { n: "DA-DH", name: "Rosario Dawson / Hayden Christensen as Ahsoka Tano / Anakin Skywalker" },
        { n: "DA-EG", name: "Giancarlo Esposito / Katee Sackhoff as Moff Gideon / Bo-Katan Kryze" },
        { n: "DA-EN", name: "Eman Esfandi / Natasha Liu Bordizzo as Ezra Bridger / Sabine Wren" },
        { n: "DA-JC", name: "Felicity Jones / Diego Luna as Jyn Erso / Cassian Andor" },
        { n: "DA-PG", name: "Freddie Prinze Jr. / Sarah Michelle Gellar as Kanan Jarrus / Seventh Sister" },
        { n: "DA-PM", name: "Ray Park / Ewan McGregor as Darth Maul / Obi-Wan Kenobi" },
        { n: "DA-RA", name: "Tom Wilton / Tim Rose as Aftab Ackbar / Admiral Ackbar" },
        { n: "DA-RM", name: "Daisy Ridley / Ian McDiarmid as Dark Rey / Emperor Palpatine" },
    ],
  },
  {
    id: "quad-autograph-book-cards",
    type: "auto",
    title: "QUAD AUTOGRAPH BOOK CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "QAB-DSGG", name: "Mark Hamill / Rosario Dawson / Temuera Morrison / Pedro Pascal as Luke Skywalker / Ahsoka Tano / Boba Fett / The Mandalorian" },
        { n: "QAB-DWBE", name: "Mary Elizabeth Winstead / Natasha Liu Bordizzo / Eman Esfandi / Rosario Dawson as Hera Syndulla / Sabine Wren / Ezra Bridger / Ahsoka Tano" },
        { n: "QAB-MPPH", name: "Domnall Gleeson / Andy Serkis / Adam Driver / Richard Grant as General Hux / Supreme Leader Snoke / Supreme Leader Kylo Ren / General Pryde" },
    ],
  },
  {
    id: "stormtrooper-armor-autograph-variation",
    type: "auto",
    title: "STORMTROOPER ARMOR AUTOGRAPH VARIATION",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SA-D", name: "Dante Briggins as Stormtrooper" },
        { n: "SA-S", name: "Sam Witwer as Stormtrooper" },
    ],
  },
  {
    id: "triple-autographs",
    type: "auto",
    title: "TRIPLE AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "TA-AT", name: "Rosario Dawson / Mary Elizabeth Winstead / Natasha Liu Bordizzo as Ahsoka Tano / Hera Syndulla / Sabine Wren" },
        { n: "TA-EMP", name: "Billy Dee Williams / David Prowse / Jeremy Bulloch as Lando Calrissian / Darth Vader / Boba Fett" },
        { n: "TA-GP", name: "Daisy Ridley / Natalie Portman / Carrie Fisher as Rey / Queen Amidala / Princess Leia" },
        { n: "TA-ROJ", name: "Peter Mayhew / Mark Hamill / Harrison Ford as Chewbacca / Luke Skywalker / Han Solo" },
    ],
  },
  {
    id: "sketch-cards",
    type: "sketch",
    title: "SKETCH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SK-1", name: "Angel Aviles" },
        { n: "SK-2", name: "Ashley Marsh" },
        { n: "SK-3", name: "Ben Jones" },
        { n: "SK-4", name: "Mayumi Seto" },
        { n: "SK-5", name: "Carlos Cabaleiro" },
        { n: "SK-6", name: "Cisco Rivera" },
        { n: "SK-7", name: "Dan Bergren" },
        { n: "SK-8", name: "Gabe Farber" },
        { n: "SK-9", name: "Jamison Murdock" },
        { n: "SK-10", name: "Jason Davies" },
        { n: "SK-11", name: "Josh Trout" },
        { n: "SK-12", name: "DYJ" },
        { n: "SK-13", name: "Kris Penix" },
        { n: "SK-14", name: "Shyla Lee" },
        { n: "SK-15", name: "Yves Van Berlo" },
        { n: "SK-16", name: "Aaron Lenahan" },
        { n: "SK-17", name: "Adam Beck" },
        { n: "SK-18", name: "Allen Grimes" },
        { n: "SK-19", name: "Andy Hanks" },
        { n: "SK-20", name: "Anthony Pietszak" },
        { n: "SK-21", name: "Basak Kahraman" },
        { n: "SK-22", name: "Bobby Blakey" },
        { n: "SK-23", name: "Brandon Klein" },
        { n: "SK-24", name: "Brandon \"B.Done\" Blevins" },
        { n: "SK-25", name: "Chris Thorne" },
        { n: "SK-26", name: "Christoffer Allen Victoria" },
        { n: "SK-27", name: "Clinton Yeager" },
        { n: "SK-28", name: "Cory Payne, CMP" },
        { n: "SK-29", name: "Dan Cooney" },
        { n: "SK-30", name: "Dan Lawler" },
        { n: "SK-31", name: "Dan Gorman" },
        { n: "SK-32", name: "Dave Wilson" },
        { n: "SK-33", name: "David Willingham" },
        { n: "SK-34", name: "Debjit Kar" },
        { n: "SK-35", name: "Derek A Johnson" },
        { n: "SK-36", name: "Dirk Shearer" },
        { n: "SK-37", name: "Emre VARLIBAŞ" },
        { n: "SK-38", name: "Ian McKesson" },
        { n: "SK-39", name: "J.Hammond" },
        { n: "SK-40", name: "Jackson \"JackArts\" Ong" },
        { n: "SK-41", name: "Jake Minor" },
        { n: "SK-42", name: "James Harris" },
        { n: "SK-43", name: "Jamie Richards" },
        { n: "SK-44", name: "Jane Rushton" },
        { n: "SK-45", name: "Jason Sobol" },
        { n: "SK-46", name: "Jeffrey C. Benitez" },
        { n: "SK-47", name: "Jessica Van Dusen" },
        { n: "SK-48", name: "Joey Mason" },
        { n: "SK-49", name: "John Still" },
        { n: "SK-50", name: "John Pleak" },
        { n: "SK-51", name: "Joe Ortiz" },
        { n: "SK-52", name: "Julia McKenzie" },
        { n: "SK-53", name: "Julie-Anne" },
        { n: "SK-54", name: "Karl Jones" },
        { n: "SK-55", name: "Keith Farnum" },
        { n: "SK-56", name: "Kevin Scott Jacobs" },
        { n: "SK-57", name: "Khloe Delnick" },
        { n: "SK-58", name: "Krishna Sharma" },
        { n: "SK-59", name: "Lukas Maurer" },
        { n: "SK-60", name: "Luke Seavers" },
        { n: "SK-61", name: "Marlo Agunos" },
        { n: "SK-62", name: "Matt Steffens" },
        { n: "SK-63", name: "Matt Stewart" },
        { n: "SK-64", name: "Michael Munshaw" },
        { n: "SK-65", name: "Mike J Sealie" },
        { n: "SK-66", name: "Mike LaPeruta" },
        { n: "SK-67", name: "Mike Dalzell" },
        { n: "SK-68", name: "Mongola Das" },
        { n: "SK-69", name: "Neil Camera" },
        { n: "SK-70", name: "Neil A Brady" },
        { n: "SK-71", name: "Nick Sutphin" },
        { n: "SK-72", name: "Oscar Chavez" },
        { n: "SK-73", name: "Patrick Giles" },
        { n: "SK-74", name: "Rich \"RAM\" Molinelli" },
        { n: "SK-75", name: "Rob Demers" },
        { n: "SK-76", name: "Rusty Gilligan" },
        { n: "SK-77", name: "Ryan Edwards" },
        { n: "SK-78", name: "Ryan Thompson" },
        { n: "SK-79", name: "Ryan Johnston" },
        { n: "SK-80", name: "Scott West" },
        { n: "SK-81", name: "Sean Mathews" },
        { n: "SK-82", name: "Srijan Das" },
        { n: "SK-83", name: "Rico Dela Rosa" },
        { n: "SK-84", name: "Vincenzo \"Chenduz\" D'Ippolito" },
        { n: "SK-85", name: "Zach Woolsey" },
        { n: "SK-86", name: "Alex Mines" },
        { n: "SK-87", name: "Angelina Benedetti" },
        { n: "SK-88", name: "Brent Scotchmer" },
        { n: "SK-89", name: "Candice Dailey" },
        { n: "SK-90", name: "Cyrus Sherkat" },
        { n: "SK-91", name: "Daniel Chavez" },
        { n: "SK-92", name: "Dan Tearle" },
        { n: "SK-93", name: "Darrin Pepe" },
        { n: "SK-94", name: "Dave Gaskin" },
        { n: "SK-95", name: "Douglas Stromenger" },
        { n: "SK-96", name: "Eddie Rhodes III" },
        { n: "SK-97", name: "Eric Lehtonen" },
        { n: "SK-98", name: "Frank A. Kadar" },
        { n: "SK-99", name: "Gerry Garcia Jr" },
        { n: "SK-100", name: "Jason Christner" },
        { n: "SK-101", name: "Jason Saldajeno" },
        { n: "SK-102", name: "Jay Manchand" },
        { n: "SK-103", name: "Jonathan Beistline" },
        { n: "SK-104", name: "Kang Jing" },
        { n: "SK-105", name: "Kevin Graham" },
        { n: "SK-106", name: "Kyle Babbitt" },
        { n: "SK-107", name: "Lindsey Greyling" },
        { n: "SK-108", name: "Madison Emerick" },
        { n: "SK-109", name: "Marcia Dye" },
        { n: "SK-110", name: "Patricio Carrasco" },
        { n: "SK-111", name: "Rebeca Louro" },
        { n: "SK-112", name: "Rugved Bhuskute" },
        { n: "SK-113", name: "Sammy Gomez" },
        { n: "SK-114", name: "Semra Bulut" },
        { n: "SK-115", name: "Steve Alce" },
        { n: "SK-116", name: "Veronica Louro" },
        { n: "SK-117", name: "Will Pleydon" },
        { n: "SK-118", name: "Aleksandr Gigov" },
        { n: "SK-119", name: "Andrew Fry" },
        { n: "SK-120", name: "Antni Ellison" },
        { n: "SK-121", name: "Roy Cover" },
        { n: "SK-122", name: "Sir Edmund Duke" },
        { n: "SK-123", name: "Brent Ragland" },
        { n: "SK-124", name: "Candice Clemmons" },
        { n: "SK-125", name: "Charlie Cody" },
        { n: "SK-126", name: "Dan Curto" },
        { n: "SK-127", name: "Daniel Riveron" },
        { n: "SK-128", name: "Dawn Murphy" },
        { n: "SK-129", name: "Don Pedicini Jr" },
        { n: "SK-130", name: "David \"Dove\" McHargue" },
        { n: "SK-131", name: "Dwayne Carpenter" },
        { n: "SK-132", name: "Dylan Riley" },
        { n: "SK-133", name: "Elvin A Hernandez" },
        { n: "SK-134", name: "Emrah Cildir" },
        { n: "SK-135", name: "Eric Medina" },
        { n: "SK-136", name: "Erik Muller" },
        { n: "SK-137", name: "Evgheni Batu" },
        { n: "SK-138", name: "Frank Sansone" },
        { n: "SK-139", name: "Garrett Dix" },
        { n: "SK-140", name: "Isiah Xavier Bradley" },
        { n: "SK-141", name: "Jaime Lopez" },
        { n: "SK-142", name: "Jim O'Riley" },
        { n: "SK-143", name: "James Boyd" },
        { n: "SK-144", name: "Jim Dickson" },
        { n: "SK-145", name: "Jason Queen" },
        { n: "SK-146", name: "Jason Montoya" },
        { n: "SK-147", name: "Jason Adams" },
        { n: "SK-148", name: "Jessica Hickman" },
        { n: "SK-149", name: "John \"JAR\" Rodriguez" },
        { n: "SK-150", name: "John Bruce" },
        { n: "SK-151", name: "Kevin Cleveland" },
        { n: "SK-152", name: "Limuel Pinzon" },
        { n: "SK-153", name: "Mathilde Machuel" },
        { n: "SK-154", name: "Matt Maldonado" },
        { n: "SK-155", name: "Matthew Sutton" },
        { n: "SK-156", name: "Michael Mastermaker" },
        { n: "SK-157", name: "Nathaniel Howard" },
        { n: "SK-158", name: "Nick Gribbon" },
        { n: "SK-159", name: "Patrick Richardson" },
        { n: "SK-160", name: "Phillip Trujillo" },
        { n: "SK-161", name: "Rachel Jane Hetherington" },
        { n: "SK-162", name: "Rees Chua-Finlay" },
        { n: "SK-163", name: "Rich Hennemann" },
        { n: "SK-164", name: "El Smetchö" },
        { n: "SK-165", name: "Robert Hendrickson" },
        { n: "SK-166", name: "Rutvig Vaid" },
        { n: "SK-167", name: "Ryan Crosby" },
        { n: "SK-168", name: "Ryan Finley" },
        { n: "SK-169", name: "Ryan Moffett" },
        { n: "SK-170", name: "Ryan Olsen" },
        { n: "SK-171", name: "Sam Barugh" },
        { n: "SK-172", name: "Sean Earey" },
        { n: "SK-173", name: "Shaow Siong" },
        { n: "SK-174", name: "Stephane Leonardi" },
        { n: "SK-175", name: "Ted Dastick Jr" },
        { n: "SK-176", name: "Tim Shinn" },
        { n: "SK-177", name: "Tom Amici" },
        { n: "SK-178", name: "Tony Riley" },
        { n: "SK-179", name: "Traci Easterday" },
        { n: "SK-180", name: "Vini Pirani" },
        { n: "SK-181", name: "Ward Silverman" },
        { n: "SK-182", name: "Mike Stephens" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
